import React from 'react';
import PropTypes from 'prop-types';
import { PrsButton, PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';
import { ButtonsContainer } from './BackAndSaveControlSetStyles';

const BackAndSaveControlSet = ({ onBack, onSave, allFieldsValid }) => (
  <ButtonsContainer>
    <PrsButton className="back-button" onClick={onBack}>Back</PrsButton>
    <PrsDefaultButton className="save-button" onClick={onSave} disabled={!allFieldsValid}>Complete Setup</PrsDefaultButton>
  </ButtonsContainer>
);

BackAndSaveControlSet.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  allFieldsValid: PropTypes.bool.isRequired,
};

export default BackAndSaveControlSet;
